document.querySelectorAll(".swiper-double").forEach((moduleEl, idx) => {
  // top slider
  new Swiper(moduleEl.querySelector(".swiper-top"), {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });

  // bottom slider (reversed)
  new Swiper(moduleEl.querySelector(".swiper-bottom"), {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      reverseDirection: true,
      disableOnInteraction: false,
    },
  });
});
